export default __webpack_public_path__ + "static/media/social.0c2a4e4c.svg";